module.exports = __webpack_public_path__ + "img/zjdxfset.447a1bc2.png";